import urlBuilder from "./urlBuilder";
import { PAGE_TYPE } from "../pages/page.types";
import getUmbracoEndPoint from "./UmbracoEndPoint";

interface ContentByRouteResponse {
    statusCode: number;
    statusText?: string;
    items: PAGE_TYPE[];
}

export default async (route: string, term: string): Promise<ContentByRouteResponse> => {
    const url = urlBuilder("/api/search", { route: route, term: term, page: "0", take: "5" });

    const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Origin": getUmbracoEndPoint(),
            "X-Request-Domain": getUmbracoEndPoint()
        },
        body: undefined
    });

    return await response.json();
};